import {
    DFM_APPROVAL_REQUIRED,
    DFM_APPROVED,
    DFM_NEEDS_FICTIV_REVIEW,
    DFM_NO_ACTION_REQUIRED,
    DFM_PENDING_REVISION,
    DFM_REVISION_REQUIRED,
    DFM_STATES,
    DFM_WARNING_ACCEPTED,
    DFM_WARNING,
    ImDfmStateType,
    DFM_FICTIV_REVIEW_REQUESTED,
} from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'

const DFM_APPROVAL_REQUIRED_TITLE = 'Please review and approve DFM'
const DFM_APPROVAL_REQUIRED_SUBTITLE =
    'Fictiv requires your approval on this DFM to proceed.'
const DFM_APPROVAL_REQUIRED_BUTTON_TXT = 'Approve DFM'

const DFM_NEEDS_FICTIV_REVIEW_TITLE = 'Pending Fictiv review'
const DFM_NEEDS_FICTIV_REVIEW_SUBTITLE =
    'Your annotations/comments will be reviewed by Fictiv once you submit a request for review.'

const DFM_REVISION_REQUIRED_SUBTITLE =
    'Please review the manufacturability feedback provided.'
const DFM_REVISION_REQUIRED_BUTTON_TXT = 'Mark for revision'

const DFM_WARNING_SUBTITLE =
    'By accepting this warning, you are acknowledging the risks associated with this DFM.'
const DFM_WARNING_BUTTON_TXT = 'Accept DFM warning'

const DFM_FICTIV_REVIEW_REQUESTED_SUBTITLE =
    'Your annotations/comments are being reviewed by a Fictiv engineer.'

const SUCCESS_ALERT = 'success'
const INFO_ALERT = 'info'
const WARNING_ALERT = 'warning'
const ERROR_ALERT = 'error'

export const DFM_STATUS_ACTIONS: {
    [key in ImDfmStateType]: {
        buttonTxt?: string
        canAnnotate: boolean
        description?: string
        message: string
        type?:
            | typeof SUCCESS_ALERT
            | typeof INFO_ALERT
            | typeof WARNING_ALERT
            | typeof ERROR_ALERT
    }
} = {
    [DFM_APPROVED]: {
        canAnnotate: false,
        message: DFM_STATES[DFM_APPROVED],
        type: 'success',
    },
    [DFM_APPROVAL_REQUIRED]: {
        buttonTxt: DFM_APPROVAL_REQUIRED_BUTTON_TXT,
        canAnnotate: true,
        description: DFM_APPROVAL_REQUIRED_SUBTITLE,
        message: DFM_APPROVAL_REQUIRED_TITLE,
        type: 'warning',
    },
    [DFM_NEEDS_FICTIV_REVIEW]: {
        canAnnotate: true,
        description: DFM_NEEDS_FICTIV_REVIEW_SUBTITLE,
        message: DFM_NEEDS_FICTIV_REVIEW_TITLE,
        type: 'info',
    },
    [DFM_NO_ACTION_REQUIRED]: {
        canAnnotate: true,
        message: DFM_STATES[DFM_NO_ACTION_REQUIRED],
    },
    [DFM_PENDING_REVISION]: {
        message: DFM_STATES[DFM_PENDING_REVISION],
        canAnnotate: false,
        type: 'error',
    },
    [DFM_REVISION_REQUIRED]: {
        buttonTxt: DFM_REVISION_REQUIRED_BUTTON_TXT,
        canAnnotate: true,
        description: DFM_REVISION_REQUIRED_SUBTITLE,
        message: DFM_STATES[DFM_REVISION_REQUIRED],
        type: 'error',
    },
    [DFM_WARNING]: {
        buttonTxt: DFM_WARNING_BUTTON_TXT,
        canAnnotate: true,
        description: DFM_WARNING_SUBTITLE,
        message: DFM_STATES[DFM_WARNING],
        type: 'warning',
    },
    [DFM_WARNING_ACCEPTED]: {
        canAnnotate: false,
        message: DFM_STATES[DFM_WARNING_ACCEPTED],
        type: 'success',
    },
    [DFM_FICTIV_REVIEW_REQUESTED]: {
        canAnnotate: true,
        description: DFM_FICTIV_REVIEW_REQUESTED_SUBTITLE,
        message: DFM_STATES[DFM_FICTIV_REVIEW_REQUESTED],
        type: 'info',
    },
}
